import { benefitSummarySection } from './benefit-summary-section'
import { policyValueTableSection } from './policy-value-table-section'
import { investmentBenefitTableSection } from './invesment-benefit-table-section'

export const section = {
  policyValueTable: policyValueTableSection,
  benefitSummary: benefitSummarySection,
  investmentBenefitTable: investmentBenefitTableSection,
}
